module.exports = __webpack_public_path__ + "static/media/clothing-min.5cbb79fb.jpg";